import { addMessages, _, init, getLocaleFromNavigator } from 'svelte-i18n';
import locale from '../config/locale.json';
import Cookies from 'js-cookie';

export const initI18n = () => {
	for (let el in locale) {
		addMessages(el, locale[el]);
	}
	const currentLang = Cookies.get('lang');
	init({
		fallbackLocale: 'ko',
		initialLocale: currentLang || getLocaleFromNavigator().substring(0,2),
	});
};
